import React from 'react';
import PropTypes from 'prop-types';

import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';
import { getArticlePath } from 'dpl/prismic/utils';
import SmartImage from 'dpl/components/SmartImage';
import RichText from 'dpl/prismic/components/RichText';
import BylineNames from 'dpl/prismic/article/components/BylineNames';

export default function MagazineFrontPageSecondaryArticle({ article }) {
  const authors = article.data.authors.map(f => f.author.data).filter(Boolean);

  return (
    <div className="PrismicMagazineFrontPageSecondaryArticle">
      <a className="db" href={getArticlePath(article)}>
        <div className="d-flex flex-row flex-row-reverse d-lg-block">
          <div className="PrismicMagazineFrontPageSecondaryArticle__imageContainer mb0 mb3-lg overflow-hidden br1">
            <div className="aspect-ratio aspect-ratio--6x4 f0 transition grow">
              <div className="aspect-ratio--object">
                {article.data.seo_image && article.data.seo_image.url && (
                  <SmartImage
                    Tag="div"
                    className="w-100 h-100 bg-center cover"
                    lazy
                    src={article.data.seo_image.url}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="pr4 pr0-lg flex-auto">
            {article.data.title && article.data.title.length > 0 && (
              <p className="fw-medium">{RichText.asText(article.data.title)}</p>
            )}
            {authors.length > 0 && (
              <div className="mt2 d-none d-md-block f2">
                By <BylineNames authors={authors} />
              </div>
            )}
          </div>
        </div>
      </a>
    </div>
  );
}

MagazineFrontPageSecondaryArticle.propTypes = {
  article: PropTypes.shape({
    data: PropTypes.shape({
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          // eslint-disable-next-line react/forbid-prop-types
          data: PropTypes.object
        })
      ),
      seo_image: PropTypes.shape({
        url: PropTypes.string
      }),
      title: StructuredTextPropTypes
    }).isRequired
  }).isRequired
};
